import { Group } from './group';
/**
 * The GroupX transform group data by x channel, and aggregate.
 */
export const GroupX = (options = {}) => {
    return Group(Object.assign(Object.assign({}, options), { channels: ['x', 'color', 'series'] }));
};
GroupX.props = {};
//# sourceMappingURL=groupX.js.map